import loginReducer from './auth.reducers';
import navigatorReducer from './navigator.reducers';
import notificationReducers from './notification.reducers';
import courseReducer from './course.reducers';
import testReducer from './test.reducers';
import checklistReducer from './checklist.reducers';
import ChecklistItemGroupReducer from './checklistItemGroup.reducers';
import socialWallReducer from './socialwall.reducers';
import checklistItemReducer from './checklistItem.reducers';

const appReducers = {
  authentication: loginReducer,
  navigator: navigatorReducer,
  notification: notificationReducers,
  courses: courseReducer,
  tests: testReducer,
  socialwall: socialWallReducer,
  checklist: checklistReducer,
  checklistItemGroup: ChecklistItemGroupReducer,
  checklistItem: checklistItemReducer,
};

export default appReducers;



// WEBPACK FOOTER //
// ./src/app/reducers/index.js